export default __webpack_public_path__ + "static/media/female.fab911a8.png";